/** Per-match combat and exploration stats for the end screen. */
export class FpsMatchStats {
  damageDealt = 0;
  shotsFired = 0;
  shotsHit = 0;

  recordShot(): void {
    this.shotsFired += 1;
  }

  recordHit(): void {
    this.shotsHit += 1;
  }

  recordDamage(amount: number): void {
    if (!Number.isFinite(amount) || amount <= 0) return;
    this.damageDealt += amount;
  }

  accuracyPercent(): number {
    if (this.shotsFired <= 0) return 0;
    return Math.round((this.shotsHit / this.shotsFired) * 100);
  }

  getTotalDamage(): number {
    return Math.round(this.damageDealt);
  }

  /** Match stats grid HTML — chestsOpened and distanceM reuse live counters from FPSGame. */
  buildGridHtml(chestsOpened: number, distanceM: number): string {
    const acc = this.accuracyPercent();
    const cell = (value: string, label: string, color: string, delay: string) =>
      `<div class="vr-stat-card" style="animation-delay:${delay};padding:12px 10px;border-radius:11px;` +
      `background:linear-gradient(180deg,rgba(255,255,255,0.08) 0%,rgba(255,255,255,0.03) 100%);` +
      `border:1px solid rgba(255,255,255,0.1);box-shadow:inset 0 1px 0 rgba(255,255,255,0.06)">` +
      `<div style="font:800 18px system-ui;color:${color}">${value}</div>` +
      `<div style="font:700 9px system-ui;color:#778899;margin-top:4px;letter-spacing:0.08em">${label}</div></div>`;
    return (
      '<div style="margin-top:20px;padding:16px 14px;border-radius:14px;' +
      'background:rgba(8,14,28,0.42);border:1px solid rgba(255,255,255,0.1);width:min(92vw,420px)">' +
      '<div style="font:700 10px system-ui;color:#8899aa;letter-spacing:0.12em;margin-bottom:12px">MATCH STATS</div>' +
      '<div style="display:grid;grid-template-columns:repeat(3,minmax(72px,1fr));gap:10px">' +
      cell(String(Math.round(this.damageDealt)), 'DAMAGE', '#ff9f7a', '0.08s') +
      cell(`${acc}%`, 'ACCURACY', '#7ec8ff', '0.16s') +
      cell(`${this.shotsHit}/${this.shotsFired}`, 'HITS', '#ffe066', '0.24s') +
      cell(String(chestsOpened), 'CHESTS', '#c8a0ff', '0.32s') +
      cell(`${distanceM}m`, 'DISTANCE', '#8af0c8', '0.4s') +
      cell(String(this.shotsFired), 'SHOTS', '#fff', '0.48s') +
      '</div></div>'
    );
  }

  reset(): void {
    this.damageDealt = 0;
    this.shotsFired = 0;
    this.shotsHit = 0;
  }
}
